module.exports = __webpack_public_path__ + "static/img/desktop-computer.dee1bcd2.svg";